import React from "react";
import Logo from "./Logo";
import { Mail, Phone, MapPin, CalendarCheck } from "lucide-react";

const CALENDLY = "https://calendly.com/wordgumbolearningco";

const FOOTER_NAV = [
  { label: "Home", href: "#home" },
  { label: "About", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "Dyslexia Support", href: "#support" },
  { label: "Assessments", href: "#assessments" },
  { label: "Programs", href: "#programs" },
  { label: "Free Consultation", href: "#consultation" },
  { label: "Contact", href: "#contact" },
];

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-gradient-to-br from-wg-purple to-wg-purpleDeep text-white pt-20 pb-10 overflow-hidden"
    >
      <div className="relative max-w-7xl mx-auto px-5 md:px-8">
        {/* Slogan */}
        <div className="text-center">
          <div className="inline-flex flex-wrap items-center justify-center gap-3 md:gap-5 font-heading font-extrabold tracking-tight text-3xl md:text-5xl">
            <span className="text-wg-teal">Read.</span>
            <span className="text-wg-orange">Learn.</span>
            <span className="text-wg-green">Grow.</span>
            <span className="text-wg-yellow">Repeat.</span>
          </div>
          <p className="mt-4 text-white/70 max-w-xl mx-auto">
            Helping children in Belle Chasse, Louisiana build strong, confident reading skills — one stir of the pot at a time.
          </p>
          <a
            href={CALENDLY}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-schedule-btn"
            className="mt-6 inline-flex items-center gap-2 bg-wg-yellow text-wg-ink rounded-full px-6 py-3 font-semibold hover:-translate-y-0.5 transition-transform"
          >
            <CalendarCheck className="w-5 h-5" />
            Schedule Free Consultation
          </a>
        </div>

        <div className="mt-16 grid md:grid-cols-3 gap-10">
          <div>
            <a href="#home" className="inline-flex items-center" aria-label="Word Gumbo Learning Co. home">
              <Logo className="h-48 md:h-64 w-auto drop-shadow-2xl" />
            </a>
            <p className="mt-5 text-white/70 text-sm leading-relaxed max-w-sm">
              Dyslexia therapy, reading tutoring, screeners, and full dyslexia core assessments by
              Laura Cummings, M.Ed. — a certified Reading Specialist & Dyslexia Therapist.
            </p>
          </div>

          <nav aria-label="Footer" className="grid grid-cols-2 gap-2">
            {FOOTER_NAV.map((n) => (
              <a
                key={n.href}
                href={n.href}
                data-testid={`footer-nav-${n.label.toLowerCase().replace(/\s+/g, "-")}-link`}
                className="text-white/80 hover:text-wg-yellow wg-link text-sm py-1"
              >
                {n.label}
              </a>
            ))}
          </nav>

          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-3">
              <MapPin className="w-4 h-4 mt-1 text-wg-yellow" />
              <span className="text-white/80">Belle Chasse, Louisiana</span>
            </li>
            <li className="flex items-start gap-3">
              <Mail className="w-4 h-4 mt-1 text-wg-yellow" />
              <a href="mailto:wordgumbolearningco@gmail.com" className="text-white/90 hover:text-wg-yellow wg-link break-all">
                wordgumbolearningco@gmail.com
              </a>
            </li>
            <li className="flex items-start gap-3">
              <Phone className="w-4 h-4 mt-1 text-wg-yellow" />
              <a href="tel:+15049494042" className="text-white/90 hover:text-wg-yellow wg-link">
                504-949-4042
              </a>
            </li>
          </ul>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 text-center text-white/60 text-xs">
          © {year} Word Gumbo Learning Co. — All rights reserved.
        </div>
      </div>
    </footer>
  );
}
